import type { SubstitutoStepProps } from "./types-substituto-step";
import { useSubstitutoStep } from "./use-substituto-step";
import { SubstitutoStepView } from "./view-substituto-step";

export function SubstitutoStep(props: SubstitutoStepProps) {
  const vm = useSubstitutoStep(props);

  return <SubstitutoStepView {...vm} />;
}

export type * from "./types-substituto-step";
